module.exports = __webpack_public_path__ + "static/media/12.0d9182bd.png";